<div class="modal fade" id={{modelId}} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" id="modal">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row modal-heading-row">
                    <div class="row heading-row-right">
                        <img src="../../../../../assets/icons/logo.png" width="35px" height="32px"
                            class="d-inline-block align-top" alt="" loading="lazy" data-dismiss="modal">
                        <div class="modal-Heading">
                            {{modalName}}
                        </div>
                    </div>
                    <img src="../../../../../assets/icons/closeBlack.png" width="18px" height="18px"
                        style="cursor: pointer;" class="d-inline-block align-top" alt="" loading="lazy"
                        data-dismiss="modal">
                </div>
                <hr>
                <div>
                    <div class="modal-text">
                        <form [formGroup]="brandForm" #data>
                            <div class="col inputColTwin" style="font-size: 14px;  padding-right: 0; padding-left: 0; ">
                                <div class="rightInput">
                                    <label class="lblInput" for="fontWeight">Brand Name</label><span
                                        style="color: red;">*</span>
                                    <input type="text" formControlName="name" placeholder="Enter the Brand Name"
                                        class="form-control input" style="height: 52px; font-size: 14px;"
                                        [ngClass]="{ 'is-invalid': submitted && brandControls.name.errors }">
                                    <div *ngIf="submitted && brandControls.name.errors" class="invalid-feedback">
                                        <div *ngIf="brandControls.name.errors.required">Brand name is required!</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col inputColTwin"
                                style="font-size: 14px; margin-top: 15px;  padding-right: 0; padding-left: 0; ">
                                <div class="rightInput">
                                    <label class="lblInput" for="fontWeight">Brand Status</label><span
                                        style="color: red;">*</span>
                                    <select [ngClass]="{ 'is-invalid': submitted && brandControls.status.errors}"
                                        class="custom-select mr-sm-2" formControlName="status"
                                        style="height: 42px; font-size: 14px;" id="inlineFormCustomSelect">
                                        <option value='' selected>Choose...</option>
                                        <option *ngFor="let status of brandStatus; let i = index"
                                            value={{status.value}}>
                                            {{status.name}}</option>
                                    </select>
                                    <div class="invalid-feedback d-block"
                                        *ngIf="submitted && brandControls.status.errors?.required">
                                        <div>Brand status is required!</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col inputColTwin"
                                style="font-size: 14px; margin-top: 15px; padding-right: 0; padding-left: 0; ">
                                <div class="rightInput">
                                    <label class="lblInput" for="fontWeight">Brand Domain</label><span
                                        style="color: red;">*</span>
                                    <input type="text" formControlName="domain" placeholder="Enter the Brand Domain"
                                        class="form-control input" style="height: 52px; font-size: 14px;"
                                        [ngClass]="{ 'is-invalid': submitted && brandControls.domain.errors }">
                                    <div *ngIf="submitted && brandControls.domain.errors" class="invalid-feedback">
                                        <div *ngIf="brandControls.domain.errors.required">Brand domain is required!
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div class="col-md-12 modal-button-div">
                        <button class="btn modal-btn-button" type="button"
                            (click)="modalType == 'Add' ? onAddClick() : onEditClick()">
                            <span *ngIf="!loading">{{modalName == 'Edit Modal' ? 'Save' : 'Add Brand'}}</span>
                            <div *ngIf="loading" style="position: absolute;">
                                <ngx-spinner bdColor="rgba(255,255,255,0)" size="small" color="#ffffff"
                                    type="ball-clip-rotate" [fullScreen]="false"></ngx-spinner>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>